module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"like_text":"도움돼요","unlike_text":"도움안돼요","already_submitted":"이미 선택 하셨습니다. 브라우져 새로고침을 해주세요 :)","comment":"댓글"}}')
  delete Component.options._Ctor
}
